import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";

import LoadingButton from "../../Buttons/Loading";
import { setClient } from "../../../store/features/clients/slice";
import * as appsyncOperations from "../../../utils/appsyncOperations";

const ChangeClientPasswordDialog = ({
  isOpen,
  onClose,
  clientId,
  serviceProviderId,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: yup.object({
      password: yup.string().min(8, "Must be at least eight characters"),
    }),
    onSubmit: async (values, actions) => {
      try {
        const updatedClient = await appsyncOperations.setClientPassword({
          id: clientId,
          password: values.password,
          serviceProviderId,
        });
        dispatch(setClient({ client: updatedClient }));
        enqueueSnackbar("Password successfully updated!", {
          variant: "success",
        });
        onClose();
      } catch (error) {
        enqueueSnackbar(
          typeof error === "string" ? error : "An unexpected error occurred.",
          {
            variant: "error",
          }
        );
      }
      actions.setSubmitting(false);
    },
  });
  useEffect(() => {
    if (isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Change Client Password</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              error={formik.errors.password}
              fullWidth
              helperText={formik.errors.password}
              label="Password"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.password}
              variant="filled"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          color="primary"
          isLoading={formik.isSubmitting}
          onClick={formik.handleSubmit}
        >
          Change
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeClientPasswordDialog;
